import { type IGroupedLogbooks, type ILogbooks } from "src/interfaces";
import { getObjectKeys } from "src/utils";

import { type TLogbookStatus } from "./Home.types";

export const getIds = ({ data }: any) => {
  if (data.yachtid && data.clientid && data.orgid) {
    return {
      yachtid: data.yachtid,
      clientid: data.clientid,
      orgid: data.orgid,
    };
  }
  return undefined;
};

export const groupLogbooks = (data: any) => {
  const logs = data.data.logbooks as Record<TLogbookStatus, ILogbooks>;
  const result: Record<TLogbookStatus, IGroupedLogbooks> = {
    active: [{ group: "Others", color: null, logbooks: [] }],
    available: [{ group: "Others", color: null, logbooks: [] }],
    expired: [{ group: "Others", color: null, logbooks: [] }],
  };
  const ids = getIds(data);
  if (ids) result.ids = ids;

  getObjectKeys(logs).forEach(key => {
    if (Array.isArray(logs[key])) {
      logs[key].forEach(obj => {
        if ("group" in obj) {
          result[key].unshift(obj);
        } else {
          const otherGroupObject = result[key].find(
            obj => obj.group === "Others",
          );
          if (otherGroupObject) otherGroupObject.logbooks.push(obj);
        }
      });
    }
  });
  return result;
};
